@if (!isAuthenticating()) {
  <ds-header
    id="dsHeader"
    #dsHeader
    appName="{{ title }}"
    [environmentTag]="environmentTagConfig()"
    [navBarRef]="navBar"
    class="stickyheader fullwidth logo-alignment-for-bmw"
  >
    <div class="row">
      <div class="col text-end">
        <span>
          <button ds-button icon="user" variant="ghost" size="sm">
            {{ this.username }}
          </button>
        </span>
      </div>
    </div>
  </ds-header>
  <div class="d-flex">
    <div class="nav-bar-wrapper position-sticky">
      <ds-navigation-bar
        #navBar
        [items]="navigationItems()"
      ></ds-navigation-bar>
    </div>

    <div class="container-fluid py-6x">
      <router-outlet></router-outlet>
    </div>
  </div>
}
